export type TableRowClassName<T> = string | ((instance: T) => string)

export const getRowClassName = <T>(
  row: T,
  className: TableRowClassName<T> | undefined,
) => {
  return typeof className === 'string' ? className : className?.(row)
}

export const getRowClickHandler = <T>(
  row: T,
  onRowClick?: (instance: T) => void,
) => {
  return (e: React.MouseEvent) => {
    const target = e.target as Element
    const button = target.closest('button')
    const link = target.closest('a')
    const modalBackground = target.closest('#modal-background')

    if (button || link || modalBackground) return

    /*
     * Overlays a row renders (action menu, dialog, drawer) live in a portal, so their clicks
     * never touch the row in the DOM — but React still bubbles them through the component tree,
     * twice around the state flush that closes the overlay. A row action that toggles on row
     * identity then opens and immediately closes. Only act on clicks from inside the row itself.
     */
    if (!e.currentTarget.contains(target)) return

    onRowClick?.(row)
  }
}

export const getRowTestAttributes = (rowId: string | number, testAttributePostfix?: string) => {
  if (!testAttributePostfix) return {}

  return {
    ['data-test-id']: `${testAttributePostfix}-item-${rowId}`,
  }
}
